import type { FC } from "react";

import { Button } from "@roko/ui/components/ui/button";
import { H2, Paragraph } from "@roko/ui/components/Typography";

import safetyLogo from "../../assets/enstructure-safety-logo.png";

type TNotFoundStateProps = {
  title: string;
  description: string;
  actionLabel: string;
  onAction: () => void;
};

export const NotFoundState: FC<TNotFoundStateProps> = ({
  title,
  description,
  actionLabel,
  onAction,
}) => {
  return (
    <div className="flex h-full min-h-[24rem] flex-col items-center justify-center gap-6 px-6 py-16 text-center">
      <div className="flex size-24 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white p-0.5 shadow-sm md:size-28">
        <img
          src={safetyLogo}
          alt=""
          aria-hidden
          className="size-full object-contain"
        />
      </div>

      <div className="space-y-2">
        <p className="text-sm font-semibold tracking-[0.2em] text-brand-orange uppercase">
          404
        </p>
        <H2 className="text-2xl font-semibold text-foreground md:text-3xl">
          {title}
        </H2>
        <Paragraph className="mx-auto max-w-md text-muted-foreground">
          {description}
        </Paragraph>
      </div>

      <Button
        type="button"
        onClick={onAction}
        className="h-11 rounded-full bg-brand-orange px-6 text-white shadow-none hover:bg-brand-orange/90"
      >
        {actionLabel}
      </Button>
    </div>
  );
};
